import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { communityPosts, communityCategories, hotTopics } from '../../mocks/communityData';
import Button from '../../components/base/Button';
import { getCommunityList, getCommunityAdd,getCommunityCategorys,getCommunityTags } from '../../services/community';
import { getcommunityLikeAdd, getcommunityLikeOut, getcommunityFocusAdd, getcommunityFocusOut,getcommunityFocusList} from '../../services/community';
import { configInfo,getadvertiseList } from '@/services/setting';
import { useSelector } from 'react-redux';
import { maskUsername } from '@/utils/common';
export default function Community() {
  // 搜索输入框受控状态
  const [inputValue, setInputValue] = useState('');
  // 统一帖子列表请求
  const fetchPosts = async ({ category_id = '', keyword = '',type='', order = 'sort asc', page_size = 50, page = 1 } = {}) => {
    setIsLoading(true);
    try {
      const res = await getCommunityList({ category_id, keyword,type, order, page_size, page });
      if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
        setPosts(res.data.lists);
      }
    } catch (err) {
      message.error('帖子获取失败');
    } finally {
      setIsLoading(false);
    }
  };

  // 排序映射
  function getOrderBySort(sort: string) {
    switch (sort) {
      case '最新':
        return '';
      case '最热':
        return 'sort desc';
      case '最多回复':
        return 'comment_number desc';
      default:
        return '';
    }
  }
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('全部');
  const [selectedSort, setSelectedSort] = useState('最新');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTag, setSelectedTag] = useState('');
  const [selectedAuthor, setSelectedAuthor] = useState(''); // 新增：选中的作者筛选
  const [showMyPosts, setShowMyPosts] = useState(false); // 新增：显示我的帖子
  const [currentPage, setCurrentPage] = useState(1);
  const [showNewPostModal, setShowNewPostModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState<any>(null);
  const [showMoreMenu, setShowMoreMenu] = useState<number | null>(null); // 新增：显示更多菜单
  const [newPost, setNewPost] = useState({
    title: '',
    content: '',
    category: '足球',
    tags: '',
    images: [] as string[]
  });
  const [posts, setPosts] = useState<any[]>([]);
  const [likedPosts, setLikedPosts] = useState<Set<number>>(new Set());
  const [categories, setCategories] = useState<any[]>([]); // 新增：分类状态
  const [tags, setTags] = useState<string[]>([]); // 新增：标签状态
  const [hotTopics, setHotTopics] = useState<any[]>([]); // 热门话题状态
  const [isLoading, setIsLoading] = useState(false); // 新增：加载状态
  const itemsPerPage = 10;
  const [adList, setAdList] = useState<any[]>([]);
  const settingConfigInfo = useSelector((state: any) => state.settings.configInfo);
  // 新增：当前用户名
  const currentUser = '当前用户';
  const [recommendedAuthors, setRecommendedAuthors] = useState<any[]>([]);

  // 新增：处理发布新帖弹窗
  const handleNewPostModal = () => {
    setShowNewPostModal(true);
  };

  // 新增：关闭发布新帖弹窗
  const handleCloseNewPostModal = () => {
    setShowNewPostModal(false);
    // 清空表单
    setNewPost({
      title: '',
      content: '',
      category: '足球',
      tags: '',
      images: []
    });
  };

  // 新增：处理我的帖子筛选
  const handleMyPostsFilter = (showMy=true) => {
    setShowMyPosts(!showMyPosts);
    setCurrentPage(1);
    let categoryId = '';
      if (Array.isArray(categories)) {
        const found = categories.find(
          (cat: any) => (typeof cat === 'object' ? cat.name : cat) === selectedCategory
        );
        categoryId = found && typeof found === 'object' ? found.id : '';
      }
      fetchPosts({ category_id: categoryId,type:showMy?'1':'', order: getOrderBySort(selectedSort) });
    // 自动回到顶部
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // 新增：处理作者筛选
  const handleAuthorFilter = (author: string) => {
    if (selectedAuthor === author) {
      setSelectedAuthor('');
    } else {
      setSelectedAuthor(author);
      setSearchQuery('');
      setSelectedCategory('全部');
      setSelectedTag('');
      setShowMyPosts(false);
    }
    setCurrentPage(1);
    // 自动回到顶部
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

   const handleAdClick = (url: string) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  // 新增：处理新帖表单变更
  const handleNewPostChange = (field: string, value: string) => {
    setNewPost(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // 新增：处理发布帖子
  const handlePublishPost = async () => {
    if (!newPost.title.trim() || !newPost.content.trim()) return;

    const tagsArray = newPost.tags.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);

    // 获取分类id
    let categoryId = '';
    if (Array.isArray(categories)) {
      const found = categories.find(
        (cat: any) => (typeof cat === 'object' ? cat.name : cat) === newPost.category
      );
      categoryId = found && typeof found === 'object' ? found.id : '';
    }
    // 构造API参数，category_id为分类id
    const params = {
      category_id: categoryId,
      title: newPost.title,
      content: newPost.content,
      // 可根据接口实际需求添加tags/images
    };

    try {
      const res = await getCommunityAdd(params);
      if (res && res.status === 1) {
        // 发布成功后刷新帖子列表
        const postRes = await getCommunityList({ category_id: '', keyword: '', page_size: 50, page: 1 });
        if (postRes && postRes.status === 1 && Array.isArray(postRes.data?.lists)) {
          setPosts(postRes.data.lists);
        }
        handleCloseNewPostModal();
        // 显示成功提示
        const successDiv = document.createElement('div');
        successDiv.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 animate-in slide-from-top-2 duration-300 flex items-center';
        successDiv.innerHTML = '<i class="ri-check-line mr-2"></i>'+res?.info || '帖子发布成功';
        document.body.appendChild(successDiv);
        setTimeout(() => {
          if (document.body.contains(successDiv)) {
            successDiv.classList.add('animate-out', 'slide-out-to-top-2');
            setTimeout(() => {
              if (document.body.contains(successDiv)) {
                document.body.removeChild(successDiv);
              }
            }, 300);
          }
        }, 3000);
      } else {
        // 发布失败
        message.error(res?.data?.msg || '发布失败，请稍后重试');
      }
    } catch (err) {
      message.error('发布失败，请检查网络或稍后重试');
    }
  };

  // 新增：处理更多按钮点击
  const handleMoreClick = (e: React.MouseEvent, postId: number) => {
    e.stopPropagation(); // 阻止事件冒泡
    setShowMoreMenu(showMoreMenu === postId ? null : postId);
  };

  // 新增：处理更多菜单项点击
  const handleMoreAction = (action: string, post: any) => {
    setShowMoreMenu(null);
    
    switch (action) {
      case 'share':
        setSelectedPost(post);
        setShowShareModal(true);
        break;
      case 'bookmark':
        showActionSuccess('已收藏该帖子');
        break;
      case 'report':
        showActionSuccess('举报已提交，我们会尽快处理');
        break;
      case 'follow':
        showActionSuccess(`已关注 ${post.author}`);
        break;
      case 'unfollow':
        showActionSuccess(`已取消关注 ${post.author}`);
        break;
      case 'hide':
        // 隐藏帖子
        setPosts(prev => prev.filter(p => p.id !== post.id));
        showActionSuccess('已隐藏该帖子');
        break;
      case 'edit':
        // 编辑帖子（仅作者可见）
        setNewPost({
          title: post.title,
          content: post.content,
          category: post.category,
          tags: post.tags ? post.tags.join(', ') : '',
          images: post.images || []
        });
        setShowNewPostModal(true);
        break;
      case 'delete':
        // 删除帖子（仅作者可见）
        if (confirm('确定要删除这个帖子吗？此操作无法撤销。')) {
          setPosts(prev => prev.filter(p => p.id !== post.id));
          showActionSuccess('帖子已删除');
        }
        break;
      case 'copylink':
        // 复制链接
        const postUrl = `${window.location.origin}/community/${post.id}`;
        navigator.clipboard.writeText(postUrl).then(() => {
          showActionSuccess('帖子链接已复制到剪贴板');
        }).catch(() => {
          showActionSuccess('链接复制失败，请手动复制');
        });
        break;
      default:
        console.log('更多操作:', action, post);
    }
  };

  // 新增：显示操作成功提示
  const showActionSuccess = (message: string) => {
    const successDiv = document.createElement('div');
    successDiv.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 animate-in slide-from-top-2 duration-300 flex items-center';
    successDiv.innerHTML = `<i class="ri-check-line mr-2"></i>${message}`;
    document.body.appendChild(successDiv);

    setTimeout(() => {
      if (document.body.contains(successDiv)) {
        successDiv.classList.add('animate-out', 'slide-out-to-top-2');
        setTimeout(() => {
          if (document.body.contains(successDiv)) {
            document.body.removeChild(successDiv);
          }
        }, 300);
      }
    }, 3000);
  };

  // 新增：点击外部关闭更多菜单
  const handleOutsideClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if (!target.closest('.more-menu-container')) {
      setShowMoreMenu(null);
    }
  };

  // 监听点击事件来关闭更多菜单
  useEffect(() => {
    if (showMoreMenu !== null) {
      document.addEventListener('click', handleOutsideClick);
      return () => {
        document.removeEventListener('click', handleOutsideClick);
      };
    }
  }, [showMoreMenu]);

  // 处理帖子点击 - 跳转到详情页
  // 处理帖子点击 - 跳转到详情页（携带帖子数据）
  const handlePostClick = (post: any) => {
    navigate(`/community/${post.id}`, { state: { post } });
  };

  // 新增：处理分享按钮点击
  const handleShareClick = (e: React.MouseEvent, post: any) => {
    e.stopPropagation(); // 阻止事件冒泡
    setSelectedPost(post);
    setShowShareModal(true);
  };

  // 新增：关闭分享弹窗
  const handleCloseShareModal = () => {
    setShowShareModal(false);
    setSelectedPost(null);
  };

  // 新增：处理分享到不同平台
  const handleShareToPlatform = (platform: string, post: any) => {
    const shareUrl = `${window.location.origin}/community/${post.id}`;
    const shareTitle = post.title;
    const shareContent = post.content.substring(0, 100) + '...';

    switch (platform) {
      case 'wechat':
        // 微信分享 - 复制链接到剪贴板
        navigator.clipboard
          .writeText(`${shareTitle}\n${shareContent}\n${shareUrl}`)
          .then(() => {
            showShareSuccess('链接已复制到剪贴板，可在微信中粘贴分享');
          })
          .catch(() => {
            showShareSuccess('复制失败，请手动复制链接');
          });
        break;

      case 'qq':
        // QQ分享
        const qqUrl = `https://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(
          shareUrl
        )}&title=${encodeURIComponent(shareTitle)}&summary=${encodeURIComponent(
          shareContent
        )}`;
        window.open(qqUrl, '_blank');
        break;

      case 'weibo':
        // 微博分享
        const weiboUrl = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(
          shareUrl
        )}&title=${encodeURIComponent(shareTitle + ' ' + shareContent)}`;
        window.open(weiboUrl, '_blank');
        break;

      case 'douyin':
        // 抖音分享 - 复制链接
        navigator.clipboard
          .writeText(`${shareTitle}\n${shareContent}\n${shareUrl}`)
          .then(() => {
            showShareSuccess('链接已复制，可在抖音中粘贴分享');
          })
          .catch(() => {
            showShareSuccess('复制失败，请手动复制链接');
          });
        break;

      case 'link':
        // 复制链接
        navigator.clipboard
          .writeText(shareUrl)
          .then(() => {
            showShareSuccess('链接已复制到剪贴板');
          })
          .catch(() => {
            showShareSuccess('复制失败，请手动复制链接');
          });
        break;

      case 'qrcode':
        // 生成二维码 - 这里简化处理
        showShareSuccess('二维码功能开发中，敬请期待');
        break;

      default:
        console.log('分享到:', platform);
    }

    // 关闭分享弹窗
    handleCloseShareModal();
  };

  // 新增：显示分享成功提示
  const showShareSuccess = (message: string) => {
    const successDiv = document.createElement('div');
    successDiv.className =
      'fixed top-4 right-4 bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 animate-in slide-from-top-2 duration-300 flex items-center';
    successDiv.innerHTML = `<i class="ri-check-line mr-2"></i>${message}`;
    document.body.appendChild(successDiv);

    setTimeout(() => {
      if (document.body.contains(successDiv)) {
        successDiv.classList.add('animate-out', 'slide-out-to-top-2');
        setTimeout(() => {
          if (document.body.contains(successDiv)) {
            document.body.removeChild(successDiv);
          }
        }, 300);
      }
    }, 3000);
  };

  // 新增：处理点赞功能
  const handleLikePost = (e: React.MouseEvent, post: any) => {
    e.stopPropagation();
    const isLiked = post.already_like;
    const postId = post.id;
    if (isLiked) {
      // 取消点赞
      getcommunityLikeOut({ id: String(postId) })
        .then((res) => {
          if (res && res.status === 1) {
            setLikedPosts((prev) => {
              const newSet = new Set(prev);
              newSet.delete(postId);
              return newSet;
            });
            setPosts((prev) =>
              prev.map((post) =>
                post.id === postId ? { ...post, like_number: post.like_number - 1,already_like:0 } : post
              )
            );
            message.success('已取消点赞');
          } else {
            message.error(res?.msg || '取消点赞失败');
          }
        })
        .catch(() => message.error('取消点赞失败'));
    } else {
      // 点赞
      getcommunityLikeAdd({ id: String(postId) })
        .then((res) => {
          if (res && res.status === 1) {
            setLikedPosts((prev) => new Set([...prev, postId]));
            setPosts((prev) =>
              prev.map((post) =>
                post.id === postId ? { ...post, like_number: post.like_number + 1,already_like:1 } : post
              )
            );
            // 显示点赞动效提示
            const button = document.querySelector(`[data-post-id="${postId}"]`);
            if (button) {
              button.classList.add('animate-pulse');
              setTimeout(() => {
                button.classList.remove('animate-pulse');
              }, 600);
            }
            message.success('已点赞');
          } else {
            message.error(res?.msg || '点赞失败');
          }
        })
        .catch(() => message.error('点赞失败'));
    }
  };

  // 过滤帖子
  const filteredPosts = posts.filter((post) => {
    // 兼容API结构
    const categoryName = typeof (post as any).category === 'object' && (post as any).category !== null ? (post as any).category.name : (post as any).category;
    const author = (post as any).author ?? (post as any).username;
    const tags = Array.isArray((post as any).tags)
      ? (post as any).tags
      : typeof (post as any).tags === 'string' && (post as any).tags
        ? (post as any).tags.split(',').map((t: any) => t.trim()).filter(Boolean)
        : [];
    const matchesCategory = selectedCategory === '全部' || categoryName === selectedCategory;
    const matchesSearch =
      searchQuery === '' ||
      post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      post.content.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (author && author.toLowerCase().includes(searchQuery.toLowerCase()));
    const matchesTag = selectedTag === '' || tags.includes(selectedTag);
    const matchesAuthor = selectedAuthor === '' || author === selectedAuthor;
    const matchesMyPosts = !showMyPosts || author === currentUser;
    return (
      matchesCategory &&
      matchesSearch &&
      matchesTag &&
      matchesAuthor 
    );
  });

  const sortedPosts = [...filteredPosts].sort((a, b) => {
    // 兼容API结构
    const getLikes = (p: any) => p.likes ?? p.like_number ?? 0;
    const getComments = (p: any) => p.comments ?? p.comment_number ?? 0;
    const getCreated = (p: any) => p.createdAt ?? p.add_time ?? 0;
    switch (selectedSort) {
      case '最热':
        return getLikes(b) + getComments(b) * 2 - (getLikes(a) + getComments(a) * 2);
      case '最多回复':
        return getComments(b) - getComments(a);
      case '最新':
      default:
        return new Date(getCreated(b)).getTime() - new Date(getCreated(a)).getTime();
    }
  });

  const totalPages = Math.ceil(sortedPosts.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentPosts = sortedPosts.slice(startIndex, startIndex + itemsPerPage);

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days}天前`;
    if (hours > 0) return `${hours}小时前`;
    return '刚刚';
  };

  const formatNumber = (num: number) => {
  if (typeof num !== 'number' || isNaN(num)) return '0';
  if (num >= 1000) return `${(num / 1000).toFixed(1)}k`;
  return num.toString();
  };

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    setCurrentPage(1);
    if (query.trim()) {
      setSelectedCategory('全部');
      setSelectedTag('');
      fetchPosts({ keyword: query, order: getOrderBySort(selectedSort) });
    } else {
      fetchPosts({ order: getOrderBySort(selectedSort) });
    }
  };

  // 修改分类筛选处理函数
  const handleCategoryChange = (category: string) => {
    if (category === '全部') {
      clearAllFilters();
      fetchPosts({ order: getOrderBySort(selectedSort) });
    } else {
      setSelectedCategory(category);
      setCurrentPage(1);
      setSearchQuery('');
      setSelectedTag('');
      // 获取分类id
      let categoryId = '';
      if (Array.isArray(categories)) {
        const found = categories.find(
          (cat: any) => (typeof cat === 'object' ? cat.name : cat) === category
        );
        categoryId = found && typeof found === 'object' ? found.id : '';
      }
      fetchPosts({ category_id: categoryId, order: getOrderBySort(selectedSort) });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSortChange = (sort: string) => {
    setSelectedSort(sort);
    setCurrentPage(1);
    // 重新请求帖子列表，保持当前筛选
    if (selectedCategory !== '全部') {
      let categoryId = '';
      if (Array.isArray(categories)) {
        const found = categories.find(
          (cat: any) => (typeof cat === 'object' ? cat.name : cat) === selectedCategory
        );
        categoryId = found && typeof found === 'object' ? found.id : '';
      }
      fetchPosts({ category_id: categoryId, order: getOrderBySort(sort) });
    } else if (selectedTag) {
      fetchPosts({ keyword: selectedTag, order: getOrderBySort(sort) });
    } else if (searchQuery) {
      fetchPosts({ keyword: searchQuery, order: getOrderBySort(sort) });
    } else {
      fetchPosts({ order: getOrderBySort(sort) });
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleTagClick = (tag: string) => {
    if (selectedTag === tag) {
      setSelectedTag('');
      fetchPosts({ order: getOrderBySort(selectedSort) });
    } else {
      setSelectedTag(tag);
      setSearchQuery('');
      setSelectedCategory('全部');
      fetchPosts({ keyword: tag, order: getOrderBySort(selectedSort) });
    }
    setCurrentPage(1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const clearAllFilters = () => {
  setSelectedTag('');
  setSearchQuery('');
  setInputValue('');
  setSelectedCategory('全部');
  setSelectedSort('最新');
  setSelectedAuthor('');
  setShowMyPosts(false);
  setCurrentPage(1);
  fetchPosts({ order: getOrderBySort('最新') });
  window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const newImages: string[] = [];
      Array.from(files).forEach((file, index) => {
        if (newPost.images.length + newImages.length < 4) {
          const mockImageUrl = `https://readdy.ai/api/search-image?query=sports%20$%7BnewPost.category%7D%20community%20post%20image%20with%20$%7BnewPost.title%20%7C%7C%20content%7D%2C%20professional%20sports%20photography&width=400&height=300&seq=userpost${Date.now()}${index}&orientation=landscape`;
          newImages.push(mockImageUrl);
        }
      });
      setNewPost((prev) => ({
        ...prev,
        images: [...prev.images, ...newImages]
      }));
    }
  };

  const removeImage = (index: number) => {
    setNewPost((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index)
    }));
  };

  // 初始化加载分类、标签、帖子
  useEffect(() => {
    const fetchInit = async () => {
      setIsLoading(true);
      try {
        // 获取分类
        const catRes = await getCommunityCategorys();
        if (catRes && Array.isArray(catRes.data)) {
          setCategories([{ id: '', name: '全部' }, ...catRes.data]);
        }
        // 获取标签
        const tagsRes = await getCommunityTags();
        if (tagsRes && tagsRes.status === 1 && Array.isArray(tagsRes.data)) {
          setTags(tagsRes.data.map((t: any) => t.name || t));
        }
        // 获取热门话题（/community/tags接口）
        const hotRes = await getCommunityTags();
        if (hotRes && hotRes.status === 1 && Array.isArray(hotRes.data)) {
          setHotTopics(hotRes.data);
        }
        //获取关注列表
        getcommunityFocusList().then((res: any) => {
          if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
            const followedAuthors = res.data.lists.map((author: any) => ({
              ...author,
              is_followed: true,
            }));
            setRecommendedAuthors(followedAuthors);
            // 可以将focusIds存储在状态中以便后续使用
          }
        });

        // 默认加载全部帖子（最新）
        await fetchPosts({ order: getOrderBySort('最新') });
        // 获取广告列表
            getadvertiseList({ type: '5' }).then((res: any) => {
              if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
                setAdList(res.data.lists);
              }
            });
      } catch (err) {
        console.error('社区分类、标签或帖子获取失败:', err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchInit();
  }, []);

  const handleFollowAuthor = (author: any) => {
    const action = author.is_followed ? getcommunityFocusOut : getcommunityFocusAdd;
    action({ user_id: String(author.user_id) }).then((res) => {
      if (res && res.status === 1) {

        message.success(res.info ? '已取消关注' : '已关注');
        setRecommendedAuthors((prevAuthors) =>
          prevAuthors.filter((a) => a.id !== author.id)
        );
      } else {
        message.error(res?.info || '操作失败，请稍后重试');
      }
    });
  };
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <main className="py-3 md:py-4">
        <div className="container mx-auto px-4">
          <div className="mb-4 md:mb-5">
            <div className="text-center mb-4">
              <h1 className="text-lg md:text-xl font-bold text-gray-900 mb-1">
                体育社区
              </h1>
              <p className="text-gray-600 text-sm">
                分享你的体育见解，与运动爱好者一起交流讨论
              </p>
            </div>

            <div className="flex justify-center items-center space-x-3 mb-4">
              <Button
                onClick={handleNewPostModal}
                className="px-4 py-1.5 bg-green-500 text-white rounded-full hover:bg-green-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-add-line mr-1 text-sm"></i>
                发布新帖
              </Button>
              <Button
                onClick={handleMyPostsFilter}
                className={`px-4 py-1.5 rounded-full transition-colors text-sm whitespace-nowrap cursor-pointer ${
                  showMyPosts
                    ? 'bg-blue-500 text-white hover:bg-blue-600'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <i className="ri-user-line mr-1 text-sm"></i>
                我的帖子
              </Button>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-4 lg:gap-6">
            <div className="flex-1">
              <div className="bg-white rounded-lg shadow-sm p-3 mb-4">
                <div className="mb-3">
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none">
                      <i className="ri-search-line text-gray-400 text-sm"></i>
                    </div>
                    <input
                      type="text"
                      placeholder="搜索帖子、用户、话题..."
                      value={inputValue ?? searchQuery}
                      onChange={(e) => setInputValue(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') handleSearch(inputValue);
                      }}
                      onBlur={() => handleSearch(inputValue)}
                      className="w-full pl-8 pr-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none text-xs"
                    />
                  </div>
                </div>

                {(selectedTag ||
                  searchQuery ||
                  selectedCategory !== '全部' ||
                  selectedAuthor ||
                  showMyPosts) && (
                  <div className="mb-3 flex flex-wrap items-center gap-1.5">
                    <span className="text-xs text-gray-600">当前筛选:</span>
                    {selectedTag && (
                      <span className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-700 rounded-full text-xs">
                        #{selectedTag}
                        <button
                          onClick={() => handleTagClick(selectedTag)}
                          className="ml-1 hover:text-blue-900"
                        >
                          <i className="ri-close-line text-xs"></i>
                        </button>
                      </span>
                    )}
                    {searchQuery && (
                      <span className="inline-flex items-center px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs">
                        搜索: {searchQuery}
                        <button
                          onClick={() => handleSearch('')}
                          className="ml-1 hover:text-green-900"
                        >
                          <i className="ri-close-line text-xs"></i>
                        </button>
                      </span>
                    )}
                    {selectedCategory !== '全部' && (
                      <span className="inline-flex items-center px-2 py-1 bg-purple-100 text-purple-700 rounded-full text-xs">
                        分类: {selectedCategory}
                        <button
                          onClick={() => handleCategoryChange('全部')}
                          className="ml-1 hover:text-purple-900"
                        >
                          <i className="ri-close-line text-xs"></i>
                        </button>
                      </span>
                    )}
                    {selectedAuthor && (
                      <span className="inline-flex items-center px-2 py-1 bg-orange-100 text-orange-700 rounded-full text-xs">
                        作者: {selectedAuthor}
                        <button
                          onClick={() => handleAuthorFilter(selectedAuthor)}
                          className="ml-1 hover:text-orange-900"
                        >
                          <i className="ri-close-line text-xs"></i>
                        </button>
                      </span>
                    )}
                    {showMyPosts && (
                      <span className="inline-flex items-center px-2 py-1 bg-indigo-100 text-indigo-700 rounded-full text-xs">
                        我的帖子
                        <button
                          onClick={() => handleMyPostsFilter(false)}
                          className="ml-1 hover:text-indigo-900"
                        >
                          <i className="ri-close-line text-xs"></i>
                        </button>
                      </span>
                    )}
                    <button
                      onClick={clearAllFilters}
                      className="text-xs text-gray-500 hover:text-gray-700 underline"
                    >
                      清除全部
                    </button>
                  </div>
                )}

                <div className="flex flex-wrap gap-1.5 mb-3">
                  {categories.map((category) => {
                    const catName = typeof (category as any) === 'object' && (category as any) !== null ? (category as any).name : (category as any);
                    return (
                      <button
                        key={catName}
                        onClick={() => handleCategoryChange(catName)}
                        className={`px-2.5 py-1 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                          selectedCategory === catName
                            ? 'bg-green-500 text-white'
                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                        }`}
                      >
                        {catName}
                      </button>
                    );
                  })}
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-1.5">
                    <span className="text-xs text-gray-600">排序:</span>
                    {['最新', '最热', '最多回复'].map((sort) => (
                      <button
                        key={sort}
                        onClick={() => handleSortChange(sort)}
                        className={`px-2.5 py-0.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                          selectedSort === sort
                            ? 'bg-green-100 text-green-700'
                            : 'text-gray-600 hover:bg-gray-100'
                        }`}
                      >
                        {sort}
                      </button>
                    ))}
                  </div>
                  <span className="text-xs text-gray-500">
                    共 {filteredPosts.length} 个帖子
                  </span>
                </div>
              </div>

              <div className="space-y-2.5">
                {currentPosts.length === 0 ? (
                  <div className="bg-white rounded-lg shadow-sm p-8 text-center">
                    <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className={`${
                        showMyPosts ? 'ri-user-line' : 'ri-search-line'
                      } text-gray-400 text-lg`}></i>
                    </div>
                    <h3 className="text-base font-medium text-gray-900 mb-2">
                      {showMyPosts
                        ? '还没有发布任何帖子'
                        : selectedTag
                        ? `未找到 #${selectedTag} 相关帖子`
                        : '未找到相关帖子'}
                    </h3>
                    <p className="text-gray-500 text-sm mb-4">
                      {showMyPosts
                        ? '快去发布你的第一个帖子，分享你的体育见解吧！'
                        : selectedTag
                        ? '尝试搜索其他话题或调整筛选条件'
                        : '尝试使用其他关键词或调整筛选条件'}
                    </p>
                    <button
                      onClick={showMyPosts ? handleNewPostModal : clearAllFilters}
                      className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors text-sm cursor-pointer whitespace-nowrap"
                    >
                      {showMyPosts ? '发布新帖' : '清除筛选条件'}
                    </button>
                  </div>
                ) : (
                  currentPosts.map((post) => (
                    <div
                      key={post.id}
                      className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden cursor-pointer"
                      onClick={() => handlePostClick(post)}
                    >
                      <div className="p-3 md:p-3.5">
                        <div className="flex items-center justify-between mb-2">
                          <div className="flex items-center space-x-2.5">
                            <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                              <span className="text-white font-medium text-xs">
                                {(((post as any).author ?? (post as any).username) || '').charAt(0)}
                              </span>
                            </div>
                            <div>
                              <div className="flex items-center space-x-1.5">
                                <h4 className="font-medium text-gray-900 text-xs">
                                  {maskUsername((post as any).author ?? (post as any).username ?? '')
                                  }
                                </h4>
                                {(post as any).isVerified && (
                                  <i className="ri-verified-badge-fill text-blue-500 text-xs"></i>
                                )}
                                {(() => {
                                  const categoryName = typeof (post as any).category === 'object' && (post as any).category !== null ? (post as any).category.name : (post as any).category;
                                  return (
                                    <span
                                      className={`px-1.5 py-0.5 rounded-full text-xs ${
                                        categoryName === '足球'
                                          ? 'bg-green-100 text-green-700'
                                          : categoryName === '篮球'
                                          ? 'bg-orange-100 text-orange-700'
                                          : categoryName === '网球'
                                          ? 'bg-yellow-100 text-yellow-700'
                                          : categoryName === '游泳'
                                          ? 'bg-blue-100 text-blue-700'
                                          : categoryName === '健身'
                                          ? 'bg-purple-100 text-purple-700'
                                          : 'bg-gray-100 text-gray-700'
                                      }`}
                                    >
                                      {categoryName}
                                    </span>
                                  );
                                })()}
                                {(post as any).league && (
                                  <span className="px-1.5 py-0.5 rounded-full text-xs bg-gray-100 text-gray-600">
                                    {(post as any).league}
                                  </span>
                                )}
                                {/* 新增：帖子状态显示 */}
                                {(((post as any).author ?? (post as any).username) === currentUser && ((post as any).status ?? (post as any).state)) && (
                                  <span
                                    className={`px-1.5 py-0.5 rounded-full text-xs font-medium ${
                                      ((post as any).status ?? (post as any).state) === 'published' || ((post as any).status ?? (post as any).state) === 1
                                        ? 'bg-green-100 text-green-700'
                                        : 'bg-yellow-100 text-yellow-700'
                                    }`}
                                  >
                                    {((post as any).status ?? (post as any).state) === 'published' || ((post as any).status ?? (post as any).state) === 1
                                      ? '发表成功'
                                      : '审核中'}
                                  </span>
                                )}
                              </div>
                              <p className="text-xs text-gray-500">
                                {formatTime((post as any).createdAt ?? (post as any).add_time ?? '')}
                              </p>
                            </div>
                          </div>
                          <div className="more-menu-container relative">
                            <button
                              onClick={(e) => handleMoreClick(e, post.id)}
                              className="text-gray-400 hover:text-gray-600 cursor-pointer"
                            >
                              <i className="ri-more-line text-sm"></i>
                            </button>
                            
                            {/* 更多操作下拉菜单 */}
                            {showMoreMenu === post.id && (
                              <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 min-w-[160px] py-1">
                                {/* 通用操作 */}
                                <button
                                  onClick={() => handleMoreAction('share', post)}
                                  className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center cursor-pointer"
                                >
                                  <i className="ri-share-line mr-3 text-gray-500"></i>
                                  分享帖子
                                </button>
                                
                                <button
                                  onClick={() => handleMoreAction('copylink', post)}
                                  className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center cursor-pointer"
                                >
                                  <i className="ri-link mr-3 text-gray-500"></i>
                                  复制链接
                                </button>
                                
                                <button
                                  onClick={() => handleMoreAction('bookmark', post)}
                                  className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center cursor-pointer"
                                >
                                  <i className="ri-bookmark-line mr-3 text-gray-500"></i>
                                  收藏帖子
                                </button>

                                {/* 如果不是当前用户的帖子 */}
                                {post.author !== currentUser && (
                                  <>
                                    <div className="border-t border-gray-100 my-1"></div>
                                    
                                    <button
                                      onClick={() => handleMoreAction('follow', post)}
                                      className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center cursor-pointer"
                                    >
                                      <i className="ri-user-add-line mr-3 text-blue-500"></i>
                                      关注作者
                                    </button>
                                    
                                    <button
                                      onClick={() => handleMoreAction('hide', post)}
                                      className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center cursor-pointer"
                                    >
                                      <i className="ri-eye-off-line mr-3 text-orange-500"></i>
                                      隐藏帖子
                                    </button>
                                    
                                    <button
                                      onClick={() => handleMoreAction('report', post)}
                                      className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center cursor-pointer"
                                    >
                                      <i className="ri-flag-line mr-3 text-red-500"></i>
                                      举报帖子
                                    </button>
                                  </>
                                )}

                                {/* 如果是当前用户的帖子 */}
                                {post.author === currentUser && (
                                  <>
                                    <div className="border-t border-gray-100 my-1"></div>
                                    
                                    <button
                                      onClick={() => handleMoreAction('edit', post)}
                                      className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center cursor-pointer"
                                    >
                                      <i className="ri-edit-line mr-3 text-green-500"></i>
                                      编辑帖子
                                    </button>
                                    
                                    <button
                                      onClick={() => handleMoreAction('delete', post)}
                                      className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center cursor-pointer"
                                    >
                                      <i className="ri-delete-bin-line mr-3 text-red-500"></i>
                                      删除帖子
                                    </button>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="mb-2.5">
                          <h3 className="font-semibold text-gray-900 mb-1.5 text-xs md:text-sm">
                            {post.title}
                          </h3>
                          <p className="text-gray-600 text-xs line-clamp-2">
                            {post.content}
                          </p>
                        </div>

                        {post.images && post.images.length > 0 && (
                          <div className="mb-2.5">
                            {post.images.length === 1 ? (
                              <img
                                src={post.images[0]}
                                alt="帖子图片"
                                className="w-full h-32 md:h-40 object-cover rounded-lg"
                              />
                            ) : (
                              <div className="grid grid-cols-2 gap-1.5">
                                {post.images.slice(0, 4).map((image, index) => (
                                  <div key={index} className="relative">
                                    <img
                                      src={image}
                                      alt={`帖子图片${index + 1}`}
                                      className="w-full h-20 md:h-24 object-cover rounded-lg"
                                    />
                                    {index === 3 && post.images.length > 4 && (
                                      <div className="absolute inset-0 bg-black/50 rounded-lg flex items-center justify-center">
                                        <span className="text-white font-medium text-xs">
                                          +{post.images.length - 4}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        )}

                        {Array.isArray(tags) && tags.length > 0 && (
                          <div className="flex flex-wrap gap-1 mt-1">
                            {tags.map((tag: string, idx: number) => (
                              <span key={idx} className="px-2 py-0.5 bg-gray-100 text-gray-700 rounded-full text-xs cursor-default">
                                #{typeof tag === 'string' ? tag : ''}
                              </span>
                            ))}
                          </div>
                        )}

                        <div className="flex items-center justify-between pt-2 border-t border-gray-100">
                          <div className="flex items-center space-x-4">
                            <button
                              onClick={(e) => handleLikePost(e, post)}
                              data-post-id={post.id}
                              className={`flex items-center space-x-1 transition-all duration-200 cursor-pointer ${
                                post.already_like
                                  ? 'text-red-500 hover:text-red-600'
                                  : 'text-gray-600 hover:text-red-500'
                              }`}
                            >
                              <i
                                className={`text-sm ${
                                  post.already_like
                                    ? 'ri-heart-fill'
                                    : 'ri-heart-line'
                                }`}
                              ></i>
                              <span className="text-xs">
                                {formatNumber((post as any).likes ?? (post as any).like_number ?? 0)}
                              </span>
                            </button>
                            <div className="flex items-center space-x-1 text-gray-600">
                              <i className="ri-chat-3-line text-sm"></i>
                              <span className="text-xs">
                                {formatNumber((post as any).comments ?? (post as any).comment_number ?? 0)}
                              </span>
                            </div>
                            <button
                              onClick={(e) => handleShareClick(e, post)}
                              className="flex items-center space-x-1 text-gray-600 hover:text-green-500 cursor-pointer"
                            >
                              <i className="ri-share-line text-sm"></i>
                              <span className="text-xs">分享</span>
                            </button>
                          </div>
                          <button
                            onClick={(e) => e.stopPropagation()}
                            className="text-gray-400 hover:text-yellow-500 cursor-pointer"
                          >
                            <i className="ri-bookmark-line text-sm"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {totalPages > 1 && (
                <div className="flex items-center justify-center mt-6 space-x-1.5">
                  <button
                    onClick={() => {
                      setCurrentPage((prev) => Math.max(prev - 1, 1));
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                    disabled={currentPage === 1}
                    className="px-2.5 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer text-xs whitespace-nowrap"
                  >
                    <i className="ri-arrow-left-line mr-1"></i>
                    上一页
                  </button>

                  <div className="flex items-center space-x-1">
                    {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                      let page;
                      if (totalPages <= 5) {
                        page = i + 1;
                      } else if (currentPage <= 3) {
                        page = i + 1;
                      } else if (currentPage >= totalPages - 2) {
                        page = totalPages - 4 + i;
                      } else {
                        page = currentPage - 2 + i;
                      }

                      return (
                        <button
                          key={page}
                          onClick={() => {
                            setCurrentPage(page);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                          className={`px-2.5 py-1.5 rounded-lg cursor-pointer text-xs whitespace-nowrap ${
                            currentPage === page
                              ? 'bg-green-500 text-white'
                              : 'border border-gray-300 text-gray-600 hover:bg-gray-50'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    })}
                  </div>

                  <button
                    onClick={() => {
                      setCurrentPage((prev) =>
                        Math.min(prev + 1, totalPages)
                      );
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                    disabled={currentPage === totalPages}
                    className="px-2.5 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer text-xs whitespace-nowrap"
                  >
                    下一页
                    <i className="ri-arrow-right-line ml-1"></i>
                  </button>
                </div>
              )}
            </div>

            <div className="lg:w-72 space-y-4">
              {/* 我的帖子统计卡片 */}
              {showMyPosts && (
                <div className="bg-white rounded-lg shadow-sm p-3">
                  <h3 className="font-semibold text-gray-900 mb-3 flex items-center text-sm">
                    <i className="ri-user-line text-blue-500 mr-1.5 text-sm"></i>
                    我的帖子统计
                  </h3>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="text-center p-3 bg-green-50 rounded-lg">
                      <div className="text-lg font-bold text-green-600">
                        {posts.filter(
                          (p) => {
                            const author = (p as any).author ?? (p as any).username;
                            const status = (p as any).status ?? (p as any).state;
                            return author === currentUser && (status === 'published' || status === 1);
                          }
                        ).length}
                      </div>
                      <div className="text-xs text-green-700">已发表</div>
                    </div>
                    <div className="text-center p-3 bg-yellow-50 rounded-lg">
                      <div className="text-lg font-bold text-yellow-600">
                        {posts.filter(
                          (p) => {
                            const author = (p as any).author ?? (p as any).username;
                            const status = (p as any).status ?? (p as any).state;
                            return author === currentUser && (status === 'pending' || status === 0);
                          }
                        ).length}
                      </div>
                      <div className="text-xs text-yellow-700">审核中</div>
                    </div>
                    <div className="text-center p-3 bg-blue-50 rounded-lg">
                      <div className="text-lg font-bold text-blue-600">
                        {posts
                          .filter((p) => {
                            const author = (p as any).author ?? (p as any).username;
                            return author === currentUser;
                          })
                          .reduce((sum, p) => sum + ((p as any).likes ?? (p as any).like_number ?? 0), 0)}
                      </div>
                      <div className="text-xs text-blue-700">总点赞</div>
                    </div>
                    <div className="text-center p-3 bg-purple-50 rounded-lg">
                      <div className="text-lg font-bold text-purple-600">
                        {posts
                          .filter((p) => {
                            const author = (p as any).author ?? (p as any).username;
                            return author === currentUser;
                          })
                          .reduce((sum, p) => sum + ((p as any).comments ?? (p as any).comment_number ?? 0), 0)}
                      </div>
                      <div className="text-xs text-purple-700">总评论</div>
                    </div>
                  </div>
                  <div className="mt-3 p-2 bg-gray-50 rounded-lg">
                    <div className="flex items-center justify-between text-xs text-gray-600">
                      <span>发帖贡献</span>
                      <span>活跃作者 🏆</span>
                    </div>
                  </div>
                </div>
              )}

              <div className="bg-white rounded-lg shadow-sm p-3">
                <h3 className="font-semibold text-gray-900 mb-3 flex items-center text-sm">
                  <i className="ri-fire-line text-red-500 mr-1.5 text-sm"></i>
                  热门话题
                </h3>
                <div className="space-y-2">
                  {hotTopics.length === 0 ? (
                    <div className="text-xs text-gray-400">暂无热门话题</div>
                  ) : (
                    hotTopics.slice(0, 8).map((topic, index) => (
                      <div key={topic.id} className="flex items-center justify-between">
                        <div className="flex items-center space-x-1.5">
                          <span
                            className={`text-xs font-bold w-3 ${
                              index < 3 ? 'text-red-500' : 'text-gray-500'
                            }`}
                          >
                            {index + 1}
                          </span>
                          <span
                            onClick={() => handleTagClick(topic.name)}
                            className={`text-xs cursor-pointer transition-colors ${
                              selectedTag === topic.name
                                ? 'text-blue-800 font-medium bg-blue-100 px-1.5 py-0.5 rounded-full'
                                : 'text-gray-900 hover:text-green-600'
                            }`}
                          >
                            #{topic.name}
                          </span>
                        </div>
                        <span className="text-xs text-gray-500">
                          {topic.add_time ? topic.add_time.slice(0, 10) : ''}
                        </span>
                      </div>
                    ))
                  )}
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm p-3">
                <h3 className="font-semibold text-gray-900 mb-3 flex items-center text-sm">
                  <i className="ri-user-star-line text-yellow-500 mr-1.5 text-sm"></i>
                  推荐关注
                </h3>
                <div className="space-y-2.5">
                  {recommendedAuthors.map((author, index) => (
                    <div key={index} className="flex items-center justify-between">
                      <div
                        className="flex items-center space-x-2 cursor-pointer hover:bg-gray-50 rounded-lg p-1.5 -m-1.5 transition-colors flex-1"
                        onClick={() => handleAuthorFilter(author.username)}
                      >
                        <div
                          className={`w-7 h-7 rounded-full flex items-center justify-center ${
                            selectedAuthor === author.username ? 'bg-green-600' : 'bg-green-500'
                          }`}
                        >
                          <span className="text-white text-xs font-medium">
                            {author.username.charAt(0)}
                          </span>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center space-x-1">
                            <span
                              className={`text-xs font-medium ${
                                selectedAuthor === author.username
                                  ? 'text-green-700'
                                  : 'text-gray-900'
                              }`}
                            >
                              {author.username}
                            </span>
                            {author.verified && (
                              <i className="ri-verified-badge-fill text-blue-500 text-xs"></i>
                            )}
                            {selectedAuthor === author.username && (
                              <i className="ri-checkbox-circle-fill text-green-500 text-xs"></i>
                            )}
                          </div>
                          <span className="text-xs text-gray-500">{author.fans_number} 粉丝</span>
                        </div>
                      </div>
                      <Button
                        size="sm"
                        className={`whitespace-nowrap cursor-pointer text-xs px-3 py-1 ${
                          author.is_followed
                            ? 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                            : 'bg-green-500 text-white hover:bg-green-600'
                        }`}
                        onClick={() => handleFollowAuthor(author)}
                      >
                        {author.is_followed ? '已关注' : '关注'}
                      </Button>
                    </div>
                  ))}
                </div>
                {selectedAuthor && (
                  <div className="mt-3 p-2 bg-green-50 rounded-lg border border-green-100">
                    <div className="flex items-center space-x-2">
                      <i className="ri-filter-line text-green-600 text-sm"></i>
                      <span className="text-xs text-green-700">
                        正在显示 <span className="font-medium">{selectedAuthor}</span> 的帖子
                      </span>
                      <button
                        onClick={() => handleAuthorFilter(selectedAuthor)}
                        className="text-green-600 hover:text-green-800 text-xs underline cursor-pointer"
                      >
                        取消筛选
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* 推荐服务 */}
              <div className="bg-white rounded-lg shadow-sm p-3">
                <h3 className="font-semibold text-gray-900 mb-3 flex items-center text-sm">
                  <i className="ri-advertisement-line text-orange-500 mr-1.5 text-sm"></i>
                  推荐服务
                </h3>
                {adList.map((ad) => (
                  <div 
                    key={ad.id} 
                    className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 cursor-pointer"
                    onClick={() => handleAdClick(ad.jump_url)}
                  >
                    <div className="relative">
                      <img
                        src={settingConfigInfo?.image_server + ad.img}
                        alt={ad.title}
                        className="w-full h-32 object-cover object-top"
                      />
                      <div className="absolute inset-0 bg-black/20"></div>
                    </div>
                    
                    <div className="p-4">
                      <h4 className="font-bold text-gray-900 mb-2">{ad.title}</h4>
                      <p className="text-sm text-gray-600 mb-3">{ad.sub_title}</p>
                      <button className={`w-full bg-gradient-to-br from-blue-500 to-cyan-600 text-white py-2 px-4 rounded-lg font-medium hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap text-sm`}>
                        {ad.btn_tip}
                      </button>
                    </div>
                  </div>
                ))}

                {/* 底部推广信息 */}
                <div className="mt-4 p-2 bg-gray-50 rounded-lg border border-gray-100">
                  <div className="flex items-center justify-between text-xs text-gray-600">
                    <div className="flex items-center space-x-1">
                      <i className="ri-information-line"></i>
                      <span>广告</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span>🔥 限时优惠</span>
                      <span>⭐ 品质保证</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* 分享弹窗 */}
      {showShareModal && selectedPost && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-hidden animate-in slide-in-from-bottom-4 duration-300">
            {/* 头部 */}
            <div className="flex items-center justify-between p-4 border-b bg-gradient-to-r from-green-500 to-emerald-600 text-white">
              <div className="flex items-center space-x-3">
                <i className="ri-share-line text-xl"></i>
                <h3 className="text-lg font-semibold">分享帖子</h3>
              </div>
              <button
                onClick={handleCloseShareModal}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            {/* 帖子预览 */}
            <div className="p-4 border-b bg-gray-50">
              <div className="flex items-center space-x-3 mb-3">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                  <span className="text-white font-medium text-xs">
                    {(selectedPost.author || selectedPost.username || '').charAt(0)}
                  </span>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900 text-sm">{selectedPost.author || selectedPost.username || ''}</h4>
                  <p className="text-xs text-gray-500">{formatTime(selectedPost.createdAt)}</p>
                </div>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2 text-sm line-clamp-2">{selectedPost.title}</h3>
              <p className="text-gray-600 text-xs line-clamp-3">{selectedPost.content}</p>
            </div>

            {/* 分享选项 */}
            <div className="p-4">
              <div className="grid grid-cols-3 gap-4 mb-4">
                {/* 微信分享 */}
                <button
                  onClick={() => handleShareToPlatform('wechat', selectedPost)}
                  className="flex flex-col items-center p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                    <i className="ri-wechat-line text-white text-xl"></i>
                  </div>
                  <span className="text-xs font-medium text-gray-700">微信</span>
                </button>

                {/* QQ分享 */}
                <button
                  onClick={() => handleShareToPlatform('qq', selectedPost)}
                  className="flex flex-col items-center p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                    <i className="ri-qq-line text-white text-xl"></i>
                  </div>
                  <span className="text-xs font-medium text-gray-700">QQ</span>
                </button>

                {/* 微博分享 */}
                <button
                  onClick={() => handleShareToPlatform('weibo', selectedPost)}
                  className="flex flex-col items-center p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                    <i className="ri-weibo-line text-white text-xl"></i>
                  </div>
                  <span className="text-xs font-medium text-gray-700">微博</span>
                </button>

                {/* 抖音分享 */}
                <button
                  onClick={() => handleShareToPlatform('douyin', selectedPost)}
                  className="flex flex-col items-center p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                    <i className="ri-music-line text-white text-xl"></i>
                  </div>
                  <span className="text-xs font-medium text-gray-700">抖音</span>
                </button>

                {/* 复制链接 */}
                <button
                  onClick={() => handleShareToPlatform('link', selectedPost)}
                  className="flex flex-col items-center p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 bg-gray-500 rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                    <i className="ri-link text-white text-xl"></i>
                  </div>
                  <span className="text-xs font-medium text-gray-700">复制链接</span>
                </button>

                {/* 二维码分享 */}
                <button
                  onClick={() => handleShareToPlatform('qrcode', selectedPost)}
                  className="flex flex-col items-center p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                    <i className="ri-qr-code-line text-white text-xl"></i>
                  </div>
                  <span className="text-xs font-medium text-gray-700">二维码</span>
                </button>
              </div>

              {/* 分享统计 */}
              <div className="bg-gray-50 rounded-lg p-3">
                <div className="flex items-center justify-between text-xs text-gray-600">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center">
                      <i className="ri-heart-line mr-1"></i>
                      <span>{formatNumber(selectedPost.likes)} 点赞</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-chat-3-line mr-1"></i>
                      <span>{formatNumber(selectedPost.comments)} 评论</span>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-share-line mr-1"></i>
                    <span>分享传播好内容</span>
                  </div>
                </div>
              </div>

              {/* 温馨提示 */}
              <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-100">
                <div className="flex items-start space-x-2">
                  <i className="ri-information-line text-blue-500 text-sm mt-0.5"></i>
                  <div className="text-xs text-blue-700">
                    <p className="font-medium mb-1">分享提示</p>
                    <p>• 分享到微信需要在微信中手动粘贴链接</p>
                    <p>• 其他平台将直接跳转到分享页面</p>
                    <p>• 分享精彩内容，邀请更多朋友加入讨论</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 发布新帖弹窗 */}
      {showNewPostModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden animate-in slide-in-from-bottom-4 duration-300">
            {/* 头部 */}
            <div className="flex items-center justify-between p-6 border-b bg-gradient-to-r from-green-500 to-emerald-600 text-white">
              <div className="flex items-center space-x-3">
                <i className="ri-edit-line text-xl"></i>
                <h3 className="text-lg font-semibold">发布新帖</h3>
              </div>
              <button
                onClick={handleCloseNewPostModal}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            {/* 表单内容 */}
            <div className="p-6 max-h-[calc(90vh-140px)] overflow-y-auto">
              <div className="space-y-4">
                {/* 帖子标题 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <i className="ri-text mr-1"></i>帖子标题 *
                  </label>
                  <input
                    type="text"
                    value={newPost.title}
                    onChange={(e) => handleNewPostChange('title', e.target.value)}
                    placeholder="输入一个吸引人的标题..."
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none text-sm"
                    maxLength={100}
                  />
                  <div className="flex justify-between items-center mt-1">
                    <p className="text-xs text-gray-500">标题将显示在帖子列表中</p>
                    <span
                      className={`text-xs ${
                        newPost.title.length > 80 ? 'text-red-500' : 'text-gray-500'
                      }`}
                    >
                      {newPost.title.length}/100

                    </span>
                  </div>
                </div>

                {/* 分类选择 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <i className="ri-bookmark-line mr-1"></i>选择分类 *
                  </label>
                  <div className="grid grid-cols-5 gap-2">
                    {categories
                      .filter(category => {
                        const catName = typeof category === 'object' && category !== null ? category.name : category;
                        return catName !== '全部';
                      })
                      .map((category) => {
                        const catName = typeof category === 'object' && category !== null ? category.name : category;
                        if (typeof catName !== 'string') return null;
                        return (
                          <button
                            key={catName}
                            onClick={() => handleNewPostChange('category', catName)}
                            className={`px-3 py-2 rounded-lg text-xs font-medium transition-colors cursor-pointer ${
                              newPost.category === catName
                                ? 'bg-green-500 text-white'
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                            }`}
                          >
                            {catName}
                          </button>
                        );
                      })}
                  </div>
                </div>

                {/* 帖子内容 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <i className="ri-file-text-line mr-1"></i>帖子内容 *
                  </label>
                  <textarea
                    value={newPost.content}
                    onChange={(e) => handleNewPostChange('content', e.target.value)}
                    placeholder="分享你的想法、经验或见解...&#10;&#10;小贴士：&#10;• 详细描述你的观点&#10;• 可以分享个人经历&#10;• 提出问题引发讨论&#10;• 使用换行让内容更易读"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none resize-none text-sm"
                    rows={8}
                    maxLength={2000}
                  />
                  <div className="flex justify-between items-center mt-1">
                    <p className="text-xs text-gray-500">详细的内容更容易获得关注和回复</p>
                    <span
                      className={`text-xs ${
                        newPost.content.length > 1800 ? 'text-red-500' : 'text-gray-500'
                      }`}
                    >
                      {newPost.content.length}/2000
                    </span>
                  </div>
                </div>

                {/* 标签输入 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <i className="ri-hashtag mr-1"></i>添加标签
                  </label>
                  <input
                    type="text"
                    value={newPost.tags}
                    onChange={(e) => handleNewPostChange('tags', e.target.value)}
                    placeholder="输入相关标签，用逗号分隔，如：世界杯,足球分析,梅西"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none text-sm"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    标签有助于其他用户发现你的帖子，建议添加3-5个相关标签
                  </p>
                </div>

                {/* 图片上传 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <i className="ri-image-line mr-1"></i>上传图片
                  </label>
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-green-500 transition-colors">
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={handleImageUpload}
                      className="hidden"
                      id="image-upload"
                    />
                    <label htmlFor="image-upload" className="flex flex-col items-center cursor-pointer">
                      <i className="ri-upload-cloud-line text-3xl text-gray-400 mb-2"></i>
                      <p className="text-sm text-gray-600 mb-1">点击上传图片</p>
                      <p className="text-xs text-gray-500">支持 JPG、PNG 格式，最多4张</p>
                    </label>
                  </div>

                  {/* 已上传图片预览 */}
                  {newPost.images.length > 0 && (
                    <div className="mt-3">
                      <div className="grid grid-cols-2 gap-3">
                        {newPost.images.map((image, index) => (
                          <div key={index} className="relative group">
                            <img
                              src={image}
                              alt={`上传图片${index + 1}`}
                              className="w-full h-24 object-cover rounded-lg border"
                            />
                            <button
                              onClick={() => removeImage(index)}
                              className="absolute top-1 right-1 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
                            >
                              <i className="ri-close-line text-xs"></i>
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* 发布设置 */}
                <div className="bg-gray-50 rounded-lg p-4">
                  <h4 className="font-medium text-gray-900 mb-3 flex items-center">
                    <i className="ri-settings-line mr-2"></i>发布设置
                  </h4>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <i className="ri-eye-line text-green-500"></i>
                        <span className="text-sm text-gray-700">允许其他用户查看</span>
                      </div>
                      <div className="w-10 h-6 bg-green-500 rounded-full relative cursor-pointer">
                        <div className="w-4 h-4 bg-white rounded-full absolute top-1 left-1 transition-transform"></div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 社区规则提醒 */}
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-100">
                  <div className="flex items-start space-x-2">
                    <i className="ri-information-line text-blue-500 text-sm mt-0.5"></i>
                    <div className="text-xs text-blue-700">
                      <p className="font-medium mb-1">发帖须知</p>
                      <p>• 请发布与体育相关的内容</p>
                      <p>• 禁止发布违法、色情、暴力等不良信息</p>
                      <p>• 尊重他人，理性讨论，避免人身攻击</p>
                      <p>• 原创内容更受欢迎，转载请注明出处</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 底部按钮 */}
            <div className="flex items-center justify-between p-6 border-t bg-gray-50">
              <div className="flex items-center text-sm text-gray-500">
                <i className="ri-time-line mr-1"></i>
                <span>草稿会自动保存</span>
              </div>
              <div className="flex items-center space-x-3">
                <Button variant="outline" size="sm" onClick={handleCloseNewPostModal} className="whitespace-nowrap cursor-pointer">
                  取消
                </Button>
                <Button
                  size="sm"
                  onClick={handlePublishPost}
                  disabled={!newPost.title.trim() || !newPost.content.trim()}
                  className="px-6 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line mr-1"></i>
                  发布帖子
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
